<app-layer-config-collapsible-category
  description="Standard Vehicle"
  storageKey="bwc-standard-vehicle"
  [collapsedDefault]="false"
>
  <app-layer-control-item
    description="Heavy Rain"
    [isLayerVisibile]="isProvider4HeavyRainLayerVisible"
    [layerId]="layerIds.Provider4HeavyRain.name"
    icon="windshield-wiper"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Fog"
    [isLayerVisibile]="isProvider4FogLayerVisible"
    [layerId]="layerIds.Provider4Fog.name"
    icon="light-fog-warning"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
